// Real Destination Roofing project photos — responsive AVIF+WebP variants (480/768/1200/1320)
import hernFin480a from "@/assets/projects/hernando-galvalume-metal-roof-destination-roofing-480w.avif.asset.json";
import hernFin768a from "@/assets/projects/hernando-galvalume-metal-roof-destination-roofing-768w.avif.asset.json";
import hernFin1200a from "@/assets/projects/hernando-galvalume-metal-roof-destination-roofing-1200w.avif.asset.json";
import hernFin1320a from "@/assets/projects/hernando-galvalume-metal-roof-destination-roofing-1320w.avif.asset.json";
import hernFin480w from "@/assets/projects/hernando-galvalume-metal-roof-destination-roofing-480w.webp.asset.json";
import hernFin768w from "@/assets/projects/hernando-galvalume-metal-roof-destination-roofing-768w.webp.asset.json";
import hernFin1200w from "@/assets/projects/hernando-galvalume-metal-roof-destination-roofing-1200w.webp.asset.json";
import hernFin1320w from "@/assets/projects/hernando-galvalume-metal-roof-destination-roofing-1320w.webp.asset.json";

import crBlue480a from "@/assets/projects/crystal-river-blue-shingle-roof-destination-roofing-480w.avif.asset.json";
import crBlue768a from "@/assets/projects/crystal-river-blue-shingle-roof-destination-roofing-768w.avif.asset.json";
import crBlue1200a from "@/assets/projects/crystal-river-blue-shingle-roof-destination-roofing-1200w.avif.asset.json";
import crBlue1320a from "@/assets/projects/crystal-river-blue-shingle-roof-destination-roofing-1320w.avif.asset.json";
import crBlue480w from "@/assets/projects/crystal-river-blue-shingle-roof-destination-roofing-480w.webp.asset.json";
import crBlue768w from "@/assets/projects/crystal-river-blue-shingle-roof-destination-roofing-768w.webp.asset.json";
import crBlue1200w from "@/assets/projects/crystal-river-blue-shingle-roof-destination-roofing-1200w.webp.asset.json";
import crBlue1320w from "@/assets/projects/crystal-river-blue-shingle-roof-destination-roofing-1320w.webp.asset.json";

import homo480a from "@/assets/projects/homosassa-blue-metal-roof-installation-480w.avif.asset.json";
import homo768a from "@/assets/projects/homosassa-blue-metal-roof-installation-768w.avif.asset.json";
import homo1200a from "@/assets/projects/homosassa-blue-metal-roof-installation-1200w.avif.asset.json";
import homo1320a from "@/assets/projects/homosassa-blue-metal-roof-installation-1320w.avif.asset.json";
import homo480w from "@/assets/projects/homosassa-blue-metal-roof-installation-480w.webp.asset.json";
import homo768w from "@/assets/projects/homosassa-blue-metal-roof-installation-768w.webp.asset.json";
import homo1200w from "@/assets/projects/homosassa-blue-metal-roof-installation-1200w.webp.asset.json";
import homo1320w from "@/assets/projects/homosassa-blue-metal-roof-installation-1320w.webp.asset.json";

import hernAer480a from "@/assets/projects/hernando-galvalume-metal-roof-aerial-480w.avif.asset.json";
import hernAer768a from "@/assets/projects/hernando-galvalume-metal-roof-aerial-768w.avif.asset.json";
import hernAer1200a from "@/assets/projects/hernando-galvalume-metal-roof-aerial-1200w.avif.asset.json";
import hernAer1320a from "@/assets/projects/hernando-galvalume-metal-roof-aerial-1320w.avif.asset.json";
import hernAer480w from "@/assets/projects/hernando-galvalume-metal-roof-aerial-480w.webp.asset.json";
import hernAer768w from "@/assets/projects/hernando-galvalume-metal-roof-aerial-768w.webp.asset.json";
import hernAer1200w from "@/assets/projects/hernando-galvalume-metal-roof-aerial-1200w.webp.asset.json";
import hernAer1320w from "@/assets/projects/hernando-galvalume-metal-roof-aerial-1320w.webp.asset.json";

import lecShing480a from "@/assets/projects/lecanto-black-shingle-roof-480w.avif.asset.json";
import lecShing768a from "@/assets/projects/lecanto-black-shingle-roof-768w.avif.asset.json";
import lecShing1200a from "@/assets/projects/lecanto-black-shingle-roof-1200w.avif.asset.json";
import lecShing1320a from "@/assets/projects/lecanto-black-shingle-roof-1320w.avif.asset.json";
import lecShing480w from "@/assets/projects/lecanto-black-shingle-roof-480w.webp.asset.json";
import lecShing768w from "@/assets/projects/lecanto-black-shingle-roof-768w.webp.asset.json";
import lecShing1200w from "@/assets/projects/lecanto-black-shingle-roof-1200w.webp.asset.json";
import lecShing1320w from "@/assets/projects/lecanto-black-shingle-roof-1320w.webp.asset.json";

import floral480a from "@/assets/projects/floral-city-black-shingle-roof-installation-480w.avif.asset.json";
import floral768a from "@/assets/projects/floral-city-black-shingle-roof-installation-768w.avif.asset.json";
import floral1200a from "@/assets/projects/floral-city-black-shingle-roof-installation-1200w.avif.asset.json";
import floral1320a from "@/assets/projects/floral-city-black-shingle-roof-installation-1320w.avif.asset.json";
import floral480w from "@/assets/projects/floral-city-black-shingle-roof-installation-480w.webp.asset.json";
import floral768w from "@/assets/projects/floral-city-black-shingle-roof-installation-768w.webp.asset.json";
import floral1200w from "@/assets/projects/floral-city-black-shingle-roof-installation-1200w.webp.asset.json";
import floral1320w from "@/assets/projects/floral-city-black-shingle-roof-installation-1320w.webp.asset.json";

import lecBef480a from "@/assets/projects/lecanto-metal-roof-before-480w.avif.asset.json";
import lecBef768a from "@/assets/projects/lecanto-metal-roof-before-768w.avif.asset.json";
import lecBef1200a from "@/assets/projects/lecanto-metal-roof-before-1200w.avif.asset.json";
import lecBef1320a from "@/assets/projects/lecanto-metal-roof-before-1320w.avif.asset.json";
import lecBef480w from "@/assets/projects/lecanto-metal-roof-before-480w.webp.asset.json";
import lecBef768w from "@/assets/projects/lecanto-metal-roof-before-768w.webp.asset.json";
import lecBef1200w from "@/assets/projects/lecanto-metal-roof-before-1200w.webp.asset.json";
import lecBef1320w from "@/assets/projects/lecanto-metal-roof-before-1320w.webp.asset.json";

import lecAft480a from "@/assets/projects/lecanto-metal-roof-after-480w.avif.asset.json";
import lecAft768a from "@/assets/projects/lecanto-metal-roof-after-768w.avif.asset.json";
import lecAft1200a from "@/assets/projects/lecanto-metal-roof-after-1200w.avif.asset.json";
import lecAft480w from "@/assets/projects/lecanto-metal-roof-after-480w.webp.asset.json";
import lecAft768w from "@/assets/projects/lecanto-metal-roof-after-768w.webp.asset.json";
import lecAft1200w from "@/assets/projects/lecanto-metal-roof-after-1200w.webp.asset.json";

import lecSs480a from "@/assets/projects/lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-480w.avif.asset.json";
import lecSs768a from "@/assets/projects/lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-768w.avif.asset.json";
import lecSs1200a from "@/assets/projects/lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-1200w.avif.asset.json";
import lecSs1320a from "@/assets/projects/lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-1320w.avif.asset.json";
import lecSs480w from "@/assets/projects/lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-480w.webp.asset.json";
import lecSs768w from "@/assets/projects/lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-768w.webp.asset.json";
import lecSs1200w from "@/assets/projects/lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-1200w.webp.asset.json";
import lecSs1320w from "@/assets/projects/lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-1320w.webp.asset.json";

const set4 = (a: { url: string }, b: { url: string }, c: { url: string }, d: { url: string }) =>
  `${a.url} 480w, ${b.url} 768w, ${c.url} 1200w, ${d.url} 1320w`;
const set3 = (a: { url: string }, b: { url: string }, c: { url: string }) =>
  `${a.url} 480w, ${b.url} 768w, ${c.url} 1200w`;

export const HERNANDO_GALVALUME_FINISHED = {
  fallback: hernFin1200w.url,
  avif: set4(hernFin480a, hernFin768a, hernFin1200a, hernFin1320a),
  webp: set4(hernFin480w, hernFin768w, hernFin1200w, hernFin1320w),
  width: 1320, height: 734,
};
export const CRYSTAL_RIVER_BLUE_SHINGLE = {
  fallback: crBlue1200w.url,
  avif: set4(crBlue480a, crBlue768a, crBlue1200a, crBlue1320a),
  webp: set4(crBlue480w, crBlue768w, crBlue1200w, crBlue1320w),
  width: 1320, height: 735,
};
export const HOMOSASSA_BLUE_METAL_IN_PROGRESS = {
  fallback: homo1200w.url,
  avif: set4(homo480a, homo768a, homo1200a, homo1320a),
  webp: set4(homo480w, homo768w, homo1200w, homo1320w),
  width: 1320, height: 980,
};
export const HERNANDO_GALVALUME_AERIAL = {
  fallback: hernAer1200w.url,
  avif: set4(hernAer480a, hernAer768a, hernAer1200a, hernAer1320a),
  webp: set4(hernAer480w, hernAer768w, hernAer1200w, hernAer1320w),
  width: 1320, height: 735,
};
export const LECANTO_BLACK_SHINGLE = {
  fallback: lecShing1200w.url,
  avif: set4(lecShing480a, lecShing768a, lecShing1200a, lecShing1320a),
  webp: set4(lecShing480w, lecShing768w, lecShing1200w, lecShing1320w),
  width: 1320, height: 1763,
};
export const FLORAL_CITY_BLACK_SHINGLE = {
  fallback: floral1200w.url,
  avif: set4(floral480a, floral768a, floral1200a, floral1320a),
  webp: set4(floral480w, floral768w, floral1200w, floral1320w),
  width: 1320, height: 740,
};
export const LECANTO_METAL_BEFORE = {
  fallback: lecBef1200w.url,
  avif: set4(lecBef480a, lecBef768a, lecBef1200a, lecBef1320a),
  webp: set4(lecBef480w, lecBef768w, lecBef1200w, lecBef1320w),
  width: 1320, height: 1454,
};
export const LECANTO_METAL_AFTER = {
  fallback: lecAft1200w.url,
  avif: set3(lecAft480a, lecAft768a, lecAft1200a),
  webp: set3(lecAft480w, lecAft768w, lecAft1200w),
  width: 1320, height: 1455,
};
export const LECANTO_STANDING_SEAM_GALVALUME = {
  fallback: lecSs1200w.url,
  avif: set4(lecSs480a, lecSs768a, lecSs1200a, lecSs1320a),
  webp: set4(lecSs480w, lecSs768w, lecSs1200w, lecSs1320w),
  width: 1320, height: 588,
};

// Beverly Hills shingle replacement — IN PROGRESS project (480/768/1280)
import bhTear480a from "@/assets/projects/beverly-hills-shingle-roof-tear-off-480w.avif.asset.json";
import bhTear768a from "@/assets/projects/beverly-hills-shingle-roof-tear-off-768w.avif.asset.json";
import bhTear1280a from "@/assets/projects/beverly-hills-shingle-roof-tear-off-1280w.avif.asset.json";
import bhTear480w from "@/assets/projects/beverly-hills-shingle-roof-tear-off-480w.webp.asset.json";
import bhTear768w from "@/assets/projects/beverly-hills-shingle-roof-tear-off-768w.webp.asset.json";
import bhTear1280w from "@/assets/projects/beverly-hills-shingle-roof-tear-off-1280w.webp.asset.json";

import bhUnd480a from "@/assets/projects/beverly-hills-shingle-roof-underlayment-480w.avif.asset.json";
import bhUnd768a from "@/assets/projects/beverly-hills-shingle-roof-underlayment-768w.avif.asset.json";
import bhUnd1280a from "@/assets/projects/beverly-hills-shingle-roof-underlayment-1280w.avif.asset.json";
import bhUnd480w from "@/assets/projects/beverly-hills-shingle-roof-underlayment-480w.webp.asset.json";
import bhUnd768w from "@/assets/projects/beverly-hills-shingle-roof-underlayment-768w.webp.asset.json";
import bhUnd1280w from "@/assets/projects/beverly-hills-shingle-roof-underlayment-1280w.webp.asset.json";

import bhProg480a from "@/assets/projects/beverly-hills-shingle-replacement-in-progress-480w.avif.asset.json";
import bhProg768a from "@/assets/projects/beverly-hills-shingle-replacement-in-progress-768w.avif.asset.json";
import bhProg1280a from "@/assets/projects/beverly-hills-shingle-replacement-in-progress-1280w.avif.asset.json";
import bhProg480w from "@/assets/projects/beverly-hills-shingle-replacement-in-progress-480w.webp.asset.json";
import bhProg768w from "@/assets/projects/beverly-hills-shingle-replacement-in-progress-768w.webp.asset.json";
import bhProg1280w from "@/assets/projects/beverly-hills-shingle-replacement-in-progress-1280w.webp.asset.json";

const setBh = (a: { url: string }, b: { url: string }, c: { url: string }) =>
  `${a.url} 480w, ${b.url} 768w, ${c.url} 1280w`;

/** Tear-off stage — project still in progress. */
export const BEVERLY_HILLS_SHINGLE_TEAR_OFF = {
  fallback: bhTear1280w.url,
  avif: setBh(bhTear480a, bhTear768a, bhTear1280a),
  webp: setBh(bhTear480w, bhTear768w, bhTear1280w),
  width: 1280, height: 720,
};
/** Synthetic underlayment installed — not the finished roof surface. */
export const BEVERLY_HILLS_SHINGLE_UNDERLAYMENT = {
  fallback: bhUnd1280w.url,
  avif: setBh(bhUnd480a, bhUnd768a, bhUnd1280a),
  webp: setBh(bhUnd480w, bhUnd768w, bhUnd1280w),
  width: 1280, height: 720,
};
/** Materials staged during the in-progress replacement. */
export const BEVERLY_HILLS_SHINGLE_IN_PROGRESS = {
  fallback: bhProg1280w.url,
  avif: setBh(bhProg480a, bhProg768a, bhProg1280a),
  webp: setBh(bhProg480w, bhProg768w, bhProg1280w),
  width: 1280, height: 720,
};
